export const GET_LIST_GAME_ACTION = "GET_LIST_GAME_ACTION";
export const SET_LIST_GAME_ACTION = "SET_LIST_GAME_ACTION";
